import * as actions from "./actions";
import * as mutations from "./mutations";

export default {
  namespaced: true,

  state: {
    clickOnViki: false,
    // auth: {
    //   token: localStorage.getItem("user-token") || "",
    //   user: {
    //     id: null,
    //     email: null,
    //     role: null,
    //     first_name: null,
    //     last_name: null,
    //     backup_voip_enable: null,
    //     voip_user: null,
    //     backup_voip_user: null,
    //     profile_img: null,
    //     team_id: null,
    //     socket_session_id: null,
    //     seniority: null,
    //     extra: {},
    //     user_shifts: []
    //   }
    // },
    //  badAttemptToLogIn: false,
    // // errorInfo: null,
    // getUserId: state => {
    //   return state.auth.user.id;
    // },

    isVisitedMainPage: false,
    socketSessionId: null,
    dictionaries: {},
    showAddEditUsers: false,
    showAddEditBrokers: false,
    searchByTaskId:'',
    tabsList: [
      {
        id: 3,
        name: "COST",
        alias: "cost"
      },
      {
        id: 5,
        name: "CAMPAIGN-1",
        alias: "campaign"
      },
      {
        id: 8,
        name: "CAMPAIGN-2",
        alias: "campaign-2"
      },
      {
        id: 1,
        name: "QUESTIONS",
        alias: "questions"
      },
      {
        id: 6,
        name: "STATUS",
        alias: "status"
      }
    ],

    usersTabs: [
      {
        id: 7,
        name: "C.STATS",
        alias: "campaign stats"
      },
      {
        id: 8,
        name: "FINANCE",
        alias: "finance"
      },
      {
        id: 9,
        name: "TIMES",
        alias: "times"
      },
      {
        id: 10,
        name: "PROFITABILITY",
        alias: "profitability"
      },
      {
        id: 11,
        name: "DAILY STATS",
        alias: "daily stats"
      },
      {
        id: 12,
        name: "SHIFT MANAGEMENT",
        alias: "shift management"
      },
      {
        id: 13,
        name: "GOALS",
        alias: "goals"
      },
      {
        id: 14,
        name: "AVERAGES",
        alias: "averages"
      },
      {
        id: 15,
        name: "PHONE",
        alias: "phone"
      },
      {
        id: 16,
        name: "PERSONAL DETAILS",
        alias: "personal details"
      },
      {
        id: 17,
        name: "VIKI",
        alias: "viki"
      },
      {
        id: 18,
        name: "CHAT",
        alias: "chat"
      },
      {
        id: 19,
        name: "TASKS",
        alias: "tasks"
      },
      {
        id: 20,
        name: "GAMES/SCORES",
        alias: "games"
      }
    ],

    brokersTabs: [
      {
        id: 21,
        name: "ORDERS",
        alias: "ORDERS"
      },
      {
        id: 22,
        name: "QUESTION",
        alias: "QUESTION"
      },
      {
        id: 23,
        name: "CAMPAIGN",
        alias: "CAMPAIGN"
      },
      {
        id: 24,
        name: "FINANCE",
        alias: "FINANCE"
      },
      {
        id: 25,
        name: "DEAL",
        alias: "DEAL"
      },
      {
        id: 26,
        name: "QUOTA/PRIORITY",
        alias: "QUOTA"
      },
      {
        id: 27,
        name: "TASKS",
        alias: "TASKS"
      }
    ],

    mainTabsList: [
      {
        id: 1,
        name: "CLIENTS",
        alias: "clients"
      },

      {
        id: 2,
        name: "NR",
        alias: "na"
      },

      {
        id: 3,
        name: "NI",
        alias: "ni"
      },
      {
        id: 4,
        name: "BN",
        alias: "bn"
      },
      {
        id: 5,
        name: "NU",
        alias: "t4"
      },
      {
        id: 6,
        name: "END",
        alias: "ended"
      },

      {
        id: 7,
        name: "USERS",
        alias: "users"
      },
      {
        id: 8,
        name: "BROKERS",
        alias: "brokers"
      },
      {
        id: 9,
        name: "MERG",
        alias: "merged"
      },
      {
        id: 10,
        name: "AFFILIATION",
        alias: "affiliation"
      },
      {
        id: 11,
        name: "RECENT",
        alias: "recent"
      },
      {
        id: 12,
        name: "DWA",
        alias: "newLd"
      },
      {
        id: 13,
        name: "TOT",
        alias: "total"
      }
    ],

    shortCutsToBlocks: [
      {
        short: "DP",
        tag: "dp",
        block: "deposits",
        calendar: "DEP",
        filter: "deposit"
      },
      {
        short: "CCD",
        tag: "ccd",
        block: "deposits",
        calendar: "DEP",
        filter: "deposit"
      },
      {
        short: "RF",
        tag: "rf",
        block: "referral",
        calendar: "REF",
        filter: "referral"
      },
      {
        short: "TR",
        tag: "tr",
        block: "transfer",
        calendar: "TRA",
        filter: "transfer"
      },
      {
        short: "NA",
        tag: "na",
        block: "no_answer",
        calendar: "NA_TAG",
        filter: "na"
      },
      {
        short: "CA",
        tag: "sc",
        block: "call_again",
        calendar: "CA_F",
        filter: "scheduled_calls"
      },
      {
        short: "CA_P",
        tag: "sc-p",
        block: "call_again",
        calendar: "CA_P",
        filter: "scheduled_calls"
      },
      {
        short: "MC",
        tag: "mc",
        block: "call_again",
        calendar: "CA_P",
        filter: "scheduled_calls"
      },
      {
        short: "ACA",
        tag: "am",
        block: "call_again",
        calendar: "CA_F",
        filter: "scheduled_calls"
      },
      {
        short: "CA",
        tag: "tc",
        block: "call_again",
        calendar: "CA_F",
        filter: "scheduled_calls"
      },
      {
        short: "CA_T",
        tag: "sc",
        block: "call_again",
        calendar: "CA_F",
        filter: "today_calls"
      },
      {
        short: "CCA",
        tag: "cca",
        block: "call_again",
        calendar: "CA_F",
        filter: "today_calls"
      },
      {
        short: "LD",
        tag: "ld",
        block: "leads",
        calendar: "LEAD_TAG",
        filter: "leads"
      },
      {
        short: "NEW",
        tag: "aac",
        block: "register",
        calendar: "REG",
        filter: ""
      },
      {
        short: "LN",
        tag: "ln",
        block: "register",
        calendar: "REG",
        filter: ""
      },
      {
        short: "ONLINE",
        tag: "online",
        block: "register",
        calendar: "REG",
        filter: ""
      },
      {
        short: "ALL",
        tag: "all",
        block: "register",
        calendar: "REG",
        filter: ""
      },
      {
        short: "ASSIGN",
        tag: "assignments",
        block: "assignments",
        calendar: "ASSIGN",
        filter: ""
      },
      {
        short: "",
        tag: "",
        block: "deposits",
        calendar: "REG",
        filter: ""
      }
    ],

    reqSpecialDates: null,
    salesPersonList: [],
    clientLogs: [],
    clientId: null,
    loading: false,
    filterClientId: null,
    filterFromViki: "",
    filterClientCall: null,
    filterCaMissed: false,
    updateDepCharts: {},
    filterDepTimeFrame: null,
    transferConfirmAnswer: null,
    selectRegCalMonth: false,
    selectRegCalLastMonth: false,
    initiatedFiltering: false,
    chartsMainView: "DEP",
    campChartData: {},
    campRegDate: null,
    clientsTableSelectedTab: { tabAlias: "status", questionSection: 1 },
    clientsTableSelectedMainTab: "clients",
    clientsTableStatsObject: {},
    clientsTableCalendarSubMenuOpened: false,
    clientsTableCalendarSubMenuSubMs: {},
    ClientsDashBoardQueryParams: {},
    refreshGeneralLiveSmallStatsChart: false,
    transferChartDateRange: {},
    TransferChartTabView: null,

    nextCallsStats: [],
    NaChartDateRange: {},
    RfChartDateRange: {},
    LdChartDateRange: {},
    DpChartDateRange: {},

    NaChartData: {},
    RfChartData: {},
    LdChartData: {},
    DpChartUsersTabData: {},
    DpChartBrokersTabData: {},
    DpChartStatusesTabData: {},
    DpChartSecVoiceTabData: {},
    DpChartQuantityTabData: {},
    DpChartConversionsTabData: {},
    DpLeadingTabData: {},

    CountriesMainChartData: {},

    updateAfterCongrats: {},
    updateLiveChart: false,

    DepositClientsFilter: {},

    AsChartData: {},
    AsChartCountries: null,
    AsChartCountriesData: {},
    AsChartCampaigns: null,
    AsChartCampaignsData: {},

    AssigmentChoseName: null,
    AssigmentChoseActive: null,
    AssigmentChoseAll: null,
    AssigmentChoseAllDup: null,
    AssigmentShowCart: null,
    AssignReportsForMonth: null,
    ForTitleInfo: null,
    AssigmentChoseTimeForChart: null,
    RegCalendarDate: null,

    LastModChoseFromStatsTable: null,
    LastModChoseTimeForChart: null,
    dpChartUserData: {},

    keyWordsDataToCharts: {},
    countriesChartsData: {},
    mainGraphTabData: {},
    graphDataToTable: {},

    updateDepAfterCongrats: false,

    dpQueryFromMulti: {},

    filterDepStatus: null,

    dataFromFavs: {},
    addFavToList: null,

    DpChartTabView: null,
    enlargeCompanyTable: true,
    timer: "5",
    mainDepFilterForThreeMonths: null,
    dataTimeFiltering: null,

    selectedStatisticsTimeFrameTab: "TODAY",

    selectedMainCalendar: [],
    selectedRegCalRange: [],

    scDataToTable: {},
    regCalFilterNoDate: null,
    liveDataFilter: "ALL",

    BNTimer: {},
    SCTimer: {},
    NITimer: {},
    clearClientTags: {},
    generalChartFilter: {},
    clientsTableTab: null,

    dynamicChartUsers: {},
    dynamicChartDates: {},

    mainCalendarDates: {},

    subGraphData: {},
    liveChartDataToCalendar: {},
    calendarDates: {},

    //new charts indexes
    generalQueryObject: {},
    selectedCalendar: null,

    selectedCalendarType: {
      alias: null
    },
    multiSelectChartData: {
      data: {},
      selectedSector: "deposits",
      fromChart: false,
      selectedTab: null,
      hash: null,
      params: {},
      questionsData: {}
    },
    chartsViewBlocks: {
      1: "deposits",
      2: null,
      3: null,
      4: null
    },

    clickFromChart: {
      lastSector: null,
      subSector: null,
      data: {}
    },

    resetCalendar: {},
    selectedTopTag: "",
    selectedTag: "",
    refreshAll: false,
    DebounceAll: false,
    showReset: false,
    openCaComponent: {
      ifOpen: false,
      clientId: null,
      date: null,
      fromTable: false,
      clientObj: null
    },
    FilterToMain: {
      dep: false,
      nw: false,
      sc: false,
      ni: false,
      bn: false,
      end: false,
      nr: false,
      tr: false,
      rf: false,
      ld: false
    },
    stopProcess: false,
    requestForDate: {},
    totalSumForCrumbBtn: null,
    ColorBlind: false,

    calNameForCountries: {
      calName: null,
      color: null
    },
    openedTabTag: {
      clientId: null,
      tagName: null,
      cmd: "open"
    },
    clickedOnMatrixCountries: false,
    reOpenMultiCountry: false,

  },

  actions,
  mutations,

  getters: {
    getSearchByTaskId:state=>{
      return state.searchByTaskId;
    },
    getMultiSelectChartData: state => {
      return state.multiSelectChartData;
    },

    multiselectCalendarType: state => {
      return state.multiselectCalendarType;
    },

    getChartsViewBlocks: state => {
      let tempArr = [];
      Object.keys(state.chartsViewBlocks).map(key => {
        tempArr.push(state.chartsViewBlocks[key]);
      });
      return tempArr;
    },

    getName: state => {
      return state.AssigmentChoseName;
    },
    getActives: state => {
      return state.AssigmentChoseActive;
    },
    getDp: state => {
      return state.AssigmentChoseAll;
    },
    showCart: state => {
      return state.AssigmentShowCart;
    },
    showCartMonth: state => {
      return state.AssignReportsForMonth;
    },
    timeStart: state => {
      return state.timer;
    },

    isVisitedMainPage: state => {
      return state.isVisitedMainPage;
    },

    AddEditUsersOpened: state => {
      return state.showAddEditUsers;
    },
    AddEditBrokersOpened: state => {
      return state.showAddEditBrokers;
    },

    loading: state => {
      return state.loading;
    },

    filterClientId: state => {
      return state.filterClientId;
    },
    filterClientCall: state => {
      return state.filterClientCall;
    },
    filterCaMissed: state => {
      return state.filterCaMissed;
    },
    updateDepCharts: state => {
      return state.updateDepCharts;
    },
    filterDepTimeFrame: state => {
      return state.filterDepTimeFrame;
    }
  }
};
